import CompanyAside from '../ui/desktop/partials/CompanyAside'
import UserAside from '../ui/desktop/partials/UserAside'
import Layout from '../ui/desktop/Layout'
import TabletLayout from '../ui/tablet/Layout'
import UserForm from '../ui/shared/blocks/UserForm'
import Content from '../ui/tablet/partials/Content'
import Header from '../ui/tablet/partials/Header'

export const SignUp = {
  Desktop: {
    Layout,
    CompanyAside,
    UserAside,
  },
  Tablet: {
    Layout: TabletLayout,
    Content,
    Header,
  },
  Shared: {
    UserForm,
  },
}
